import { ANDROID_USER_AGENT_REGEX, IOS_USER_AGENT_REGEX } from './regex';

export enum DeviceType {
  IOS = 'ios',
  ANDROID = 'android',
  DESKTOP = 'desktop',
}

export const getDeviceType = (): DeviceType => {
  const userAgent = navigator.userAgent || '';

  if (IOS_USER_AGENT_REGEX.test(userAgent)) return DeviceType.IOS;
  if (ANDROID_USER_AGENT_REGEX.test(userAgent)) return DeviceType.ANDROID;

  return DeviceType.DESKTOP;
};
